var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMetroEye = function SvgIconMetroEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.933,
    height: 13.083,
    viewBox: "0 0 20.933 13.083",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.037,7.712A11.723,11.723,0,0,0,2.571,14.254a11.644,11.644,0,0,0,20.933,0A11.723,11.723,0,0,0,13.037,7.712ZM18.2,11.181a9.954,9.954,0,0,1,3.055,3.072A9.954,9.954,0,0,1,18.2,17.326a10.628,10.628,0,0,1-1.463.766,9.2,9.2,0,0,1-3.7.741,9.581,9.581,0,0,1-5.161-1.507,9.954,9.954,0,0,1-3.055-3.072,9.953,9.953,0,0,1,3.055-3.072c.08-.051.161-.1.242-.149a5.233,5.233,0,1,0,9.837,0q.122.073.242.149Zm-5.161,1.11a1.963,1.963,0,1,1-1.963-1.963A1.962,1.962,0,0,1,13.037,12.291Z",
    transform: "translate(-2.571 -7.712)",
    fill: "#8d8585"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMetroEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-metro-eye.bb7aa384.svg";
export { ForwardRef as ReactComponent };